import { createSlice } from '@reduxjs/toolkit';
import { getActiveSellList } from '../../reducers/active/activeThunks';
import { handleRequestThunk } from '../handleRequestThunk';
import { commonInitialState } from '../../../utils/common/commonInitialState';
const SLICE_NAME = 'activeSell';

export const activeSellSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getActiveSellList });
    },
});

export const selectActiveSellList = (state) => state.activeSell.data;

export const activeSell = activeSellSlice.reducer;
